<template>
	<div>
		<div id="wrap">
			<div class="flex flex-start">
				<el-form :model="queryParams" ref="formName" :inline="true">
					<div>
						<el-form-item label="知识产权编号" prop="">
							<el-input v-model="queryParams.intellectualNumber"></el-input>
						</el-form-item>
						<el-form-item label="知识产权名称" prop="">
							<el-input v-model="queryParams.intellectualName"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="handleQuery">搜索</el-button>
							<el-button type="primary" @click="resetQuery">重置</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>

			<div class="flex flex-end">
				<el-button type="primary" @click="handleAdd">新增</el-button>
			</div>

			<el-table
				class="table"
				:data="datas"
				v-loading="loading"
				:header-cell-style="{ background: '#F5F7FA' }"
				stripe
				:row-class-name="tableRowClassName"
			>
				<el-table-column label="序号" prop="date" align="center">
					<template slot-scope="scope">
						<span>{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="intellectualNumber"
					label="知识产权编号"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="intellectualName"
					label="知识产权名称"
					align="center"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column label="类别" prop="propertyTypeStr" align="center">
				</el-table-column>
				<el-table-column label="授权日期" prop="authDate" align="center">
				</el-table-column>
				<el-table-column
					label="专利号/著作权号"
					prop="patentNumber"
					align="center"
				></el-table-column>
				<el-table-column
					label="获得方式"
					show-overflow-tooltip
					prop="getMethodStr"
					align="center"
				></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							class="green"
							@click="handleUpdate(scope.row.id)"
							>编辑</el-button
						>
						<el-button
							type="text"
							size="small"
							class="red"
							@click="handleDelete(scope.row.approvalId, scope.row.id)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<div class="flex flex-end">
				<el-pagination
					class="pagination"
					background
					v-show="total > 0"
					:total="total"
					:current-page.sync="queryParams.pageNum"
					:page-size.sync="queryParams.pageSize"
					@current-change="getList"
				>
				</el-pagination>
			</div>
		</div>

		<el-dialog
			title="知识产权信息"
			:visible.sync="centerDialogVisible"
			width="66%"
			center
			v-loading="loading"
		>
			<el-form
				:model="ruleForm"
				:rules="rules"
				ref="ruleForm"
				class="demo-ruleForm"
			>
				<div>
					<div class="content" v-loading="loading">
						<!-- <p class="text">知识产权信息</p> -->
						<el-row type="flex" class="row-bg" justify="space-between">
							<el-col :span="11">
								<el-form-item
									label="知识产权编号"
									prop="highTechApprovalIntellectualPropertyBO.intellectualNumber"
									label-width="40%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="
											ruleForm.highTechApprovalIntellectualPropertyBO
												.intellectualNumber
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item label="类别" prop="area" label-width="40%">
									<!-- <el-select
                    v-model="
                      ruleForm.highTechApprovalIntellectualPropertyBO
                        .intellectualType
                    "
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="dict in intellectualType"
                      :key="dict.key"
                      :label="dict.dictName"
                      :value="dict.dictCode"
                    ></el-option>
                  </el-select> -->
									<el-cascader
										show-all-levels
										v-model="ruleForm.area"
										placeholder="请选择"
										:options="options"
										@change="cascaderChange"
									>
									</el-cascader>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="授权号"
									prop="highTechApprovalIntellectualPropertyBO.patentNumber"
									label-width="40%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="
											ruleForm.highTechApprovalIntellectualPropertyBO
												.patentNumber
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="获得方式"
									prop="highTechApprovalIntellectualPropertyBO.getMethod"
									label-width="40%"
								>
									<el-select
										v-model="
											ruleForm.highTechApprovalIntellectualPropertyBO.getMethod
										"
									>
										<el-option
											v-for="dict in getMethod"
											:key="dict.id"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									label="知识产权名称"
									prop="highTechApprovalIntellectualPropertyBO.intellectualName"
									label-width="18%"
								>
									<el-input
										:maxlength="inputMax"
										v-model="
											ruleForm.highTechApprovalIntellectualPropertyBO
												.intellectualName
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>

							<el-col :span="11">
								<el-form-item
									label="授权日期"
									prop="highTechApprovalIntellectualPropertyBO.authDate"
									label-width="40%"
								>
									<el-date-picker
										:editable="false"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions"
										v-model="
											ruleForm.highTechApprovalIntellectualPropertyBO.authDate
										"
										placeholder="请选择"
									></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="20">
								<p>
									附件：请上传知识产权相关材料(知识产权证书及反应技术水平的证明材料等,文件格式为pdf/png/jpg)
								</p>
								<div>
									<el-upload
										ref="upload"
										class="upload-demo"
										:action="uploadImgUrl"
										:on-success="quillImgSuccess"
										:on-preview="handleView"
										:on-remove="handleRemove"
										:on-error="uploadError"
										:before-upload="beforeUpload"
										:data="{ moduleType: 1 }"
										accept=".jpeg,.jpg,.png,application/pdf"
										:file-list="fileList"
									>
										<el-button size="small" type="primary">点击上传</el-button>
									</el-upload>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">返回</el-button>
				<el-button type="primary" @click="classSubmitForm" :disabled="disabled"
					>保存</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {
	getDict,
	queryCascadeDict01,
	intellectualPropertyQueryAll,
	intellectualPropertySave,
	intellectualPropertyQuery,
	getModuleFiles,
	intellectualPropertyDelete
} from "@/api/ChinaHigh";
import ThatReviewVue from "@/views/form/ThatReview/index.vue";
export default {
	name: "intellectual",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			centerDialogVisible: false,
			// 数据
			datas: [],
			// 搜索
			queryParams: {
				pageNum: 1,
				pageSize: 10
			},
			// 遮罩层
			loading: true,
			total: 0,
			// 类别
			getMethod: {},
			intellectualType: "",
			typeSecond: "",
			typeSecond2: "",
			options: [],
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			ruleForm: {
				area: [],
				fileBOList: [],
				highTechApprovalIntellectualPropertyBO: {}
			},
			rules: {
				"highTechApprovalIntellectualPropertyBO.intellectualNumber": [
					{ required: true, message: "请输入知识产权编号", trigger: "blur" },
					{ min: 0, max: 30, message: "长度最多30个字符", trigger: "blur" }
				],
				area: [
					{
						required: true,
						message: "请选择类别",
						trigger: "change",
						type: "array"
					}
				],
				"highTechApprovalIntellectualPropertyBO.patentNumber": [
					{ required: true, message: "请输入授权号", trigger: "blur" }
				],
				"highTechApprovalIntellectualPropertyBO.intellectualName": [
					{ required: true, message: "请输入知识产权名称", trigger: "blur" },
					{ min: 0, max: 200, message: "长度最多200个字符", trigger: "blur" }
				],
				"highTechApprovalIntellectualPropertyBO.getMethod": [
					{ required: true, message: "请选择获得方式", trigger: "change" }
				],
				"highTechApprovalIntellectualPropertyBO.authDate": [
					{ required: true, message: "请选择授权日期", trigger: "change" }
				]
				// "fileList":[
				//   {required: true, message: "请上传附件", trigger: "change"},
				// ]
			},
			fileList: [],
			disabled: false
		};
	},
	created() {
		this.handleQuery();
		this.chushi();
	},
	methods: {
		chushi() {
			// 企业规模
			getDict({ type: "intellectual_property_access" }).then(res => {
				this.getMethod = res.data;
			});
			queryCascadeDict01({ type: "property_type" }).then(res => {
				this.options = res.data;
			});
		},
		// typeFormat(row) {
		//   return this.selectDictLabel(this.intellectualType, row.intellectualType);
		// },
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 重置按钮操作 */
		resetQuery() {
			this.resetForm("formName");
			this.queryParams = {};
			this.handleQuery();
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.approvalId = this.id;
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 列表 */
		getList() {
			this.loading = true;
			intellectualPropertyQueryAll(this.queryParams).then(res => {
				this.datas = res.data.records;
				this.total = res.data.total;
				this.loading = false;
			});
		},
		beforeUpload(file) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (
				suffix != "jpg" &&
				suffix != "png" &&
				suffix != "jpeg" &&
				suffix != "pdf"
			) {
				this.msgError("只能上传jpg/png/pdf格式的文件");
				return false;
			}
			// this.loading = true;
			// if (file.size>1024*500){
			//     this.msgError("文件不能超过500KB");
			//     return false;
			// }
			// var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			// const extension = testmsg === "jpg";

			// const isLt2M = file.size / 1024 / 1024 <= 3;
			// if (!extension) {
			//   this.msgError("上传文件只能是图片文件");
			// }
			// if (!isLt2M) {
			//   this.msgError("上传文件大小不能超过3M");
			// }
			// return extension && isLt2M;
		},
		// 上传成功
		quillImgSuccess(res, file, fileList) {
			this.loading = false;
			// 如果上传成功
			if (res.code === "00000") {
				this.ruleForm.fileBOList.push(res.data);
				this.msgSuccess("附件上传成功");
			} else {
				this.msgError("附件上传失败");
			}
			let status = "";
			fileList.some(res => {
				if (res.status != "success") {
					status = 1;
					return;
				}
			});
		},
		// 图片删除
		handleRemove(file, fileList) {
			this.ruleForm.fileBOList = [];
			fileList.forEach(res => {
				if (res.response == undefined) {
					this.ruleForm.fileBOList.push(res);
				} else {
					this.ruleForm.fileBOList.push(res.response.data);
				}
			});
		},
		// 富文本图片上传失败
		uploadError(err, file, fileList) {
			this.loading = false;
			if (fileList.length > 0) {
				let status = "";
				fileList.some(res => {
					if (res.status != "success") {
						status = 1;
						return;
					}
				});
			} else {
				this.loading = false;
			}
			// loading动画消失
			this.msgError("图片上传失败");
		},
		cascaderChange(e) {
			this.intellectualType = e[0] + "";
			this.typeSecond = e[1];
			this.ruleForm.highTechApprovalIntellectualPropertyBO.intellectualType = this.ruleForm.area[0];
			this.ruleForm.highTechApprovalIntellectualPropertyBO.typeSecond = this.ruleForm.area[1];
		},
		classSubmitForm() {
			this.ruleForm.highTechApprovalIntellectualPropertyBO.intellectualType = this.intellectualType;
			this.ruleForm.highTechApprovalIntellectualPropertyBO.typeSecond = this.typeSecond;
			this.ruleForm.highTechApprovalIntellectualPropertyBO.approvalId = this.id;
			var files = this.$refs.upload.uploadFiles;
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					if (files.length <= 0) {
						this.msgError("请上传附件");
					} else {
						intellectualPropertySave(this.ruleForm).then(res => {
							if (res.code === "00000") {
								this.handleQuery();
								this.centerDialogVisible = false;
								this.msgSuccess(res.msg);
							}
						});
					}
				} else {
					return false;
				}
			});
		},
		qsj() {
			this.ruleForm = {
				fileBOList: [],
				highTechApprovalIntellectualPropertyBO: {}
			};
			this.fileList = [];
			this.resetFiles("upload");
			this.resetForm("ruleForm");
		},
		// 新增
		handleAdd() {
			this.ruleForm.area = [];
			this.qsj();
			this.centerDialogVisible = true;
		},
		// 修改
		handleUpdate(id) {
			this.qsj();
			// this.handleQuery();
			intellectualPropertyQuery(id).then(res => {
				this.ruleForm.highTechApprovalIntellectualPropertyBO =
					res.data.highTechApprovalIntellectualPropertyBO;

				getModuleFiles({
					moduleId: res.data.highTechApprovalIntellectualPropertyBO.id,
					moduleType: 1
				}).then(res => {
					this.ruleForm.fileBOList = res.data;

					res.data.forEach(re => {
						this.fileList.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					});
				});
				this.ruleForm.area = [];
				this.ruleForm.area.push(
					res.data.highTechApprovalIntellectualPropertyBO.intellectualType
				);
				this.ruleForm.area.push(
					res.data.highTechApprovalIntellectualPropertyBO.typeSecond
				);
				console.log(this.ruleForm.area);
				this.centerDialogVisible = true;
			});
		},
		//删除
		handleDelete(approvalId, id) {
			this.$confirm("是否确认删除项目?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return intellectualPropertyDelete({
						approvalId: approvalId,
						ids: [id]
					});
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select {
	width: 30% !important;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}
.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.accessory_box {
	width: 100%;
}
.accessory_box > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
}

.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
</style>
